import { Box, Button, SpaceBetween } from '@amzn/awsui-components-react';

import { localization } from './constants';
interface TableNoMatchStateProps {
    onClearFilter: () => void;
}
const TableNoMatchState = (props: TableNoMatchStateProps) => (
    <Box margin={{ vertical: 'xs' }} textAlign="center" color="inherit">
        <SpaceBetween size="xxs">
            <div>
                <b>{localization.NO_MATCH_TITLE}</b>
                <Box variant="p" color="inherit">
                    {localization.NO_MATCH_CONTENT}
                </Box>
            </div>
            <Button onClick={props.onClearFilter}>{localization.NO_MATCH_ACTION}</Button>
        </SpaceBetween>
    </Box>
);

export default TableNoMatchState;
